export const createSocketConnection = (profissionalSaudeId, accessToken, chatUrl) => {
  const urlSplitted = chatUrl.split('://');
  const websocketProtocol = urlSplitted[0] === 'https' ? 'wss' : 'ws';
  const websocketUrl = `${websocketProtocol}://${urlSplitted[1]}/user/${profissionalSaudeId}/token/${accessToken}`;
  const socket = new WebSocket(websocketUrl);

  return socket;
}
